import React from 'react';
import * as SVGIcons from '@/assets/icons/svgs';
import { SvgIconProps } from '@mui/material';

interface DynamicSVGProps extends SvgIconProps {
    iconName: string;
}
const DynamicSVG: React.FC<DynamicSVGProps> = ({ iconName, ...props }) => {
    const SvgIcon = SVGIcons[`${iconName}` as keyof typeof SVGIcons];

    if (!SvgIcon) {
        return <span> Icon '{iconName}'  not found</span>; // Fallback if SVG is not available
    }

    return <SvgIcon {...props} />;
};


export default DynamicSVG;